import { render, staticRenderFns } from "./updateClass.vue?vue&type=template&id=1aa37000&scoped=true"
import script from "./updateClass.vue?vue&type=script&lang=js"
export * from "./updateClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa37000",
  null
  
)

export default component.exports